import React, { Fragment, useState } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { sendAnalytics } from "../../../action/homeAction";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import Result from "./Result";
import DynamicFormComponent from "./getDynamicFormComponent";
import { CMSPath } from "../../../config/constant";

const AccompanyingGuestDynamicFrom = (props) => {

    const { t } = props;
    const [accompanyGuests, setAccompanyGuests] = useState([]);
    const [accompanyGuestIndex, setAccompanyGuestIndex] = useState(0);
    const [renderGuestDetailsForm, setRenderGuestDetailsForm] = useState(true);
    const [reRenderDynamicForm, setReRenderDynamicForm] = useState(true);

    React.useEffect(() => {

        if (props.accompanyGuests.length > 0) {
            setAccompanyGuests(props.accompanyGuests);
        }

        let label = getDefaultAnalyticsLabel({ appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : "" })
        const checkin_companion_guest_event_sent = localStorage.getItem("checkin_companion_guest_event_sent")
        if (!checkin_companion_guest_event_sent)
            props.sendAnalytics(
                null, // as no guesdetails in logout state 
                props.currentWidgetObj.widgetType || "Mobile Check-in",
                "COMPANION DETAILS",
                { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "pageName": "COMPANION DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken") },
                0,
                false, // guest is not logged in
                () => localStorage.setItem("checkin_companion_guest_event_sent", true)
            );
    }, [])

    const handleNext = (accompanyGuestData) => {
        accompanyGuests[accompanyGuestIndex] = {...accompanyGuests[accompanyGuestIndex], ...accompanyGuestData};


        if (sessionStorage.getItem("accompanyGuestDynamicFormFilledOnce")) {
            setRenderGuestDetailsForm(false);
            return;
        }

        if (accompanyGuestIndex == accompanyGuests.length - 1) {
            setRenderGuestDetailsForm(false);
            sessionStorage.setItem("accompanyGuestDynamicFormFilledOnce", true)
        } else {
            setAccompanyGuestIndex(accompanyGuestIndex + 1)
        }
    }

    const handleBack = () => {

        if (sessionStorage.getItem("accompanyGuestDynamicFormFilledOnce")) {

            if(!renderGuestDetailsForm){
                props.back();
            } else {
                setRenderGuestDetailsForm(false);
            }

            return;
        }

        if (accompanyGuestIndex == 0) {
            props.back();
        } else {
            setAccompanyGuestIndex(accompanyGuestIndex - 1)
        }
    }

    const handleAccompanyGuestSaveNext = () => {
        props.setAccompanyGuestData(accompanyGuests)
        console.log("Setting Accompaning Guest" + JSON.stringify(accompanyGuests))
        props.next()
    }

    const editCompanionDetails = (accompanyGuestIndex) => {
        setAccompanyGuestIndex(accompanyGuestIndex);
        setRenderGuestDetailsForm(true);
    }

    React.useEffect(() => {
        setReRenderDynamicForm(false);

        setTimeout(() => {
            setReRenderDynamicForm(true);
        }, 0);
    },[accompanyGuestIndex])

    React.useEffect(() => {
        if(sessionStorage.getItem("accompanyGuestDynamicFormFilledOnce")){
            setRenderGuestDetailsForm(false);
        }
    },[])

    React.useEffect(() => {
        console.log(accompanyGuests)
        console.log(accompanyGuestIndex)
    }, [accompanyGuests, accompanyGuestIndex])

    return (
        <Fragment>
            <div className="main-container" style={{ background: "url('theme/images/background/08MEDubai-Atrium.jpg') center center no-repeat", backgroundSize: "cover", backgroundAttachment: "fixed" }}>
                <header className="inner-pages w-footer subpages">
                    <a onClick={handleBack} className="button-back"></a>
                    <div className="heading align-center">
                        <div class="splash-brand">
                            <img src={`${CMSPath}${props.logo}`} />
                        </div>
                        {/* <p className="bold">{props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</p> */}
                    </div>
                </header>

                {!renderGuestDetailsForm ?
                    <>
                        <section class="widgets padding-0 margin-0 container-bg">

                            <div class="widget-header widget-header-checkin-inner">
                                { props.currentWidgetObj.widgetHeaderImageUrl && 
                                    <div class="widget-header-img">
                                        <img src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`} alt={props.currentWidgetObj.displayName} />
                                    </div>
                                }
                                <div class="widget-header-title">{props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</div>
                            </div>

                            <div class="widgets" style={{ paddingBottom: "10rem" }}>
                                <div class="row padding-top-1 padding-bottom-0 padding-right-1 padding-left-1">
                                    <h2>Companion details</h2>
                                </div>
                                <div class="form-window">
                                    <div class="form-window-heading">Review Companion Details</div>
                                    <div class="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1" style={{ borderColor: "#ccc" }}>
                                        <div class="form-row margin-bottom-1">
                                            {
                                                accompanyGuests.map((guest, index) => {
                                                    return (
                                                        <>
                                                            <div class="companion-section">
                                                                <span class="guest-name">{guest.nameTitle ? guest.nameTitle + " " + guest.firstName + " " + guest.lastName : guest.firstName + " " + guest.lastName}</span>
                                                                <span onClick={() => editCompanionDetails(index)} class="fa fa-edit"></span>
                                                            </div>
                                                        </>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <footer class="button-controls">
                            <section class="padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                                <button onClick={handleAccompanyGuestSaveNext} class="primary w-100 all-caps margin-bottom-1">{props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.precheckin') : t('check_in.checkin')}</button>
                            </section>
                        </footer>
                    </> :
                    <section class="widgets padding-0 margin-0 container-bg">

                        <div class="widget-header widget-header-checkin-inner">
                            { props.currentWidgetObj.widgetHeaderImageUrl && 
                                <div class="widget-header-img">
                                    <img src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`} alt={props.currentWidgetObj.displayName} />
                                </div>
                            }
                            <div class="widget-header-title">{props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</div>
                        </div>

                        <div class="widgets" style={{ paddingBottom: "10rem" }}>
                            <div class="row padding-top-1 padding-bottom-0 padding-right-1 padding-left-1">
                                <h2>Companion details</h2>
                            </div>

                            <div class="form-window">
                                <div class="form-window-heading">Add Companion Details #{accompanyGuestIndex + 1}</div>
                                    {reRenderDynamicForm && <DynamicFormComponent
                                        phone={accompanyGuests[accompanyGuestIndex] && accompanyGuests[accompanyGuestIndex].phone}
                                        birthDate={accompanyGuests[accompanyGuestIndex] && accompanyGuests[accompanyGuestIndex].birthDate}
                                        email={accompanyGuests[accompanyGuestIndex] && accompanyGuests[accompanyGuestIndex].email}
                                        address={accompanyGuests[accompanyGuestIndex] && accompanyGuests[accompanyGuestIndex].address}
                                        firstName={accompanyGuests[accompanyGuestIndex] && accompanyGuests[accompanyGuestIndex].firstName}
                                        lastName={accompanyGuests[accompanyGuestIndex] && accompanyGuests[accompanyGuestIndex].lastName}
                                        extraData={accompanyGuests[accompanyGuestIndex]}
                                        DynamicBookingFormRequestData={props.accompanyGuestDynamicForm}
                                        dynamicFormIndex={props.dynamicFormIndex}
                                        primaryButtonText={sessionStorage.getItem("accompanyGuestDynamicFormFilledOnce") ? t(`check_in.update`) : t(`check_in.next`)}
                                        next={handleNext}
                                        goBack={handleBack}
                                    />}
                            </div>
                        </div>
                    </section>
                }
            </div>
        </Fragment>
    )
}

const mapStateToProps = state => {
    return {
        cardChecksData: state.store2.cardChecksData,
        accompanyGuests: state.store2.accompanyGuests,
        guestDetail: state.store.home.guestDetails,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        currentHomePage: state.store2.currentHomePage,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
    }
}
export default connect(
    mapStateToProps,
    {
        closeOrderPopUp,
        sendAnalytics
    }
)(withTranslation('translations')(AccompanyingGuestDynamicFrom));